import { TtoCampaignVideoDto } from '@/app/common/general-types/tiktok-one-reporting.dto';
import { ManageBriefTabsService } from '@/app/pages/manage-brief-tabs/service/manage-brief-tabs/manage-brief-tabs.service';
import { TiktokOneReportingService } from '@/app/services/tiktok-one-reporting/tiktok-one-reporting.service';
import { Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, inject, input, OnInit, signal, ViewChild } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { CreateSparkCampaign } from '../../../../service/create-spark-campaign/create-spark-campaign';

@Component({
  selector: 'cad-select-creative',
  imports: [],
  templateUrl: './select-creative.html',
  styleUrl: './select-creative.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SelectCreative implements OnInit {

  smallMode = input<boolean>(false);

  @ViewChild('selectCreativeDrawerDialog', { static: false }) selectCreativeDrawerDialog?: ElementRef<HTMLDialogElement>;
  @ViewChild('selectCreativeDrawerButton', { static: false }) selectCreativeDrawerButton?: ElementRef<HTMLButtonElement>;

  ttoCampaign = signal<{
    code: number,
    data: {
      campaign_channel_type: string,
      campaign_id: string,
      campaign_type: string,
      page_info: {
        page: number,
        page_size: number,
        total_number: number,
        total_page: number,
      },
      tto_tcm_account_id: string,
      videos: TtoCampaignVideoDto[],
      message: string,
      request_id: string
    }
  } | undefined>(undefined);

  ttoVideos = signal<TtoCampaignVideoDto[]>([]);
  playingVideoIds = signal<ReadonlySet<string>>(new Set());
  hoveredVideoId = signal<string | undefined>(undefined);

  prelim_selectedCreative = signal<TtoCampaignVideoDto | undefined>(undefined);

  /** Services */
  private manageBriefTabsService = inject(ManageBriefTabsService);
  private ttoReportingService = inject(TiktokOneReportingService);
  private createSparkCampaignService = inject(CreateSparkCampaign);
  /** Services - END */

  ngOnInit(): void {
    this.getTtoReportingData();
  }

  async getTtoReportingData() {
    const tto_campaign_id = this.manageBriefTabsService.focussedBrief()?.shoutBrief?.ttoCampaignId;
    if (!tto_campaign_id) {
      return;
    }
    const ttoReportingData = await firstValueFrom(this.ttoReportingService.getIndividualPostResults(tto_campaign_id));
    console.log('🚨🚨🚨 111 getTtoReportingData: ', ttoReportingData);
    this.ttoCampaign.set(ttoReportingData);
    this.ttoVideos.set(ttoReportingData.data.videos);

    if (this.createSparkCampaignService.selectedCreative()) {
      this.prelim_selectedCreative.set(this.createSparkCampaignService.selectedCreative());
    }
  }  

  closeDrawer() {
    this.selectCreativeDrawerDialog?.nativeElement?.close();
  }

  setHoveredVideo(videoId: string | undefined): void {
    this.hoveredVideoId.set(videoId);
  }

  isVideoPlaying(videoId: string): boolean {
    return this.playingVideoIds().has(videoId);
  }

  onVideoPlay(videoId: string): void {
    this.playingVideoIds.update((prev) => new Set(prev).add(videoId));
  }

  onVideoPause(videoId: string): void {
    this.playingVideoIds.update((prev) => {
      const next = new Set(prev);
      next.delete(videoId);
      return next;
    });
  }

  async toggleVideoPlayback(video: HTMLVideoElement): Promise<void> {
    if (video.paused) {
      await video.play();
      return;
    }
    video.pause();
  }

  selectCreative(video: TtoCampaignVideoDto): void {
    this.prelim_selectedCreative.set(video);
  }

  isSelectedCreative(video: TtoCampaignVideoDto): boolean {
    return this.prelim_selectedCreative()?.video_info.video_id === video.video_info.video_id;
  }

  toggleCreativeSelection(video: TtoCampaignVideoDto): void {
    if (this.isSelectedCreative(video)) {
      this.prelim_selectedCreative.set(undefined);
      return;
    }
    this.prelim_selectedCreative.set(video);
  }

  hasSelectedCreative(): boolean {
    return this.prelim_selectedCreative() !== undefined;
  }

  confirmSelection() {
    this.createSparkCampaignService.selectedCreative.set(this.prelim_selectedCreative());
    this.closeDrawer();
  }
}
